/* This is metadata section for SEO
Probably you can edit this section without manually editing the component
*/

// metadata
const logotext = "React Project";
const meta = {
  title: "React Project",
  description: "Your Description"
};

// hero animated for intro
const introdata = {
  title: "Welcome to",
  animated: {
    first: "React Template",
    second: "React JS",
    third: "React Native"
  },
  description: "To get started , please click button below",
  img_url: "https://wallpaperaccess.com/full/3949076.jpg"
};

// data section , for portfolio or about me
const dataabout = {
  title: "Title",
  aboutme: "About . "
};
const worktimeline = [
  {
    jobtitle: "test",
    where: "test",
    date: "2020"
  },
  {
    jobtitle: "test",
    where: "test",
    date: "2019"
  },
  {
    jobtitle: "test",
    where: "test",
    date: "2019"
  }
];

const tech = [
  {
    name: "Progress 1",
    value: 98
  },
  {
    name: "Progress 2",
    value: 85
  },
  {
    name: "Progress 3",
    value: 50
  },
  {
    name: "Progress 4",
    value: 95
  }
];

const services = [
  {
    title: "Site",
    description: "https://yoururl.com"
  },
  {
    title: "Site",
    description: "https://yoururl.com"
  },
  {
    title: "Site ",
    description: "https://yoururl.com"
  }
];

// showcase your content here
const dataportfolio = [
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title ",
    link: "../post2"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "../post2"
  },
  {
    img: "https://miro.medium.com/max/2000/1*-Ijet6kVJqGgul6adezDLQ.png",
    desctiption: "Title",
    link: "../post2"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "../post2"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },

  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  },
  {
    img: "https://miro.medium.com/max/1400/1*CeuWv9fCjD1uTiTuKytnBQ.png",
    desctiption: "Title",
    link: "#"
  }
];

// contact
const contactConfig = {
  YOUR_EMAIL: "name@domain.com",
  YOUR_FONE: "(555)123-4567",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vehicula eu nunc et sollicitudin. Cras pulvinar, nisi at imperdiet pharetra. ",
  YOUR_SERVICE_ID: "service_id",
  YOUR_TEMPLATE_ID: "template_id",
  YOUR_USER_ID: "user_id"
};

const socialprofils = {
  github: "https://github.com",
  facebook: "https://facebook.com",
  linkedin: "https://linkedin.com",
  twitter: "https://twitter.com"
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  tech,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext
};
